export const SIGNUP_STEP = 1;
export const PASSWORD_STEP = 2;
